import { createSelector } from '@base-ui/utils/store';
export const schedulerNowSelectors = {
  showCurrentTimeIndicator: createSelector(state => state.showCurrentTimeIndicator),
  nowUpdatedEveryMinute: createSelector(state => state.nowUpdatedEveryMinute),
  isCurrentDay: createSelector(state => state.adapter, state => state.nowUpdatedEveryMinute, (adapter, now, date) => adapter.isSameDay(date, now))
};